/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconGenderNeutrois = createReactComponent("outline", "gender-neutrois", "IconGenderNeutrois", [["path", { "d": "M12 10a5 5 0 1 1 0 10a5 5 0 0 1 0 -10z", "key": "svg-0" }], ["path", { "d": "M12 10v-7", "key": "svg-1" }]]);

export { IconGenderNeutrois as default };
//# sourceMappingURL=IconGenderNeutrois.mjs.map
